<template>
  <v-container
    id="products"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-pencil-box-multiple"
      inline
      class="px-5 py-3"
      top-actions
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t('ProductManagement') }}
        </div>
      </template>

      <template v-slot:top-actions>
        <v-btn
          class="px-2 ml-1"
          color="success"
          @click="gotoNew()"
        >
          {{ $t('General.Buttons.New', ['product']) }}
        </v-btn>
        <debounce-v-btn
          class="px-2 ml-1"
          color="info"
          @click="refreshAdminProducts()"
        >
          {{ $t('General.Buttons.Refresh') }}
        </debounce-v-btn>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('General.Labels.Search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        hide-default-header
        :items="items"
        :search.sync="search"
        multi-sort
      >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th
                v-for="(header, i) in headers"
                :key="`header-${i}`"
              >
                {{ $t(header.text) }}
              </th>
            </tr>
          </thead>
        </template>

        <template v-slot:item="{ item }">
          <tr>
            <td>
              <v-btn
                class="px-2 ml-1"
                color="warning"
                rounded
                small
                @click="gotoDetails(item)"
              >
                {{ $t('General.Buttons.Edit') }}
              </v-btn>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.variants.length }}</td>
            <td>{{ item.vendor }}</td>
            <td>{{ item.published ? "Yes" : "No" }}</td>
            <td class="text-right">
              <v-btn
                class="px-2 mr-1"
                color="error"
                rounded
                small
                @click="showDeleteModal(item)"
              >
                {{ $t('General.Buttons.Delete') }}
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog
      v-model="deleteDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          {{ $t('Components.Dialogs.DeleteProduct.Title') }}
          <v-spacer />
          <v-icon
            :aria-label="$t('General.Buttons.Close')"
            @click="cancelCancel()"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="text-center font-weight-bold">
          <p>{{ $t('Components.Dialogs.DeleteProduct.Text', [deleteProductMessage]) }}</p>
        </v-card-text>
        <v-card-text class="pb-6 pt-12 text-center">
          <v-btn
            class="mr-3"
            text
            @click="cancelProductDeletion()"
          >
            {{ $t('General.Buttons.Cancel') }}
          </v-btn>

          <debounce-v-btn
            color="error"
            text
            @click="deleteProduct()"
          >
            {{ $t('General.Buttons.Delete') }}
          </debounce-v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data: () => ({
      headers: [
        {
          sortable: false,
          text: '',
          width: '1%',
        },
        {
          sortable: true,
          text: 'Pages.ManageProducts.TableHeaders.Product',
          value: 'name',
        },
        {
          sortable: true,
          text: 'Pages.ManageProducts.TableHeaders.NumberOfVariants',
          value: 'variants.length',
        },
        {
          sortable: true,
          text: 'Pages.ManageProducts.TableHeaders.Vendor',
          value: 'vendor',
        },
        {
          sortable: true,
          text: 'Pages.ManageProducts.TableHeaders.Published',
          value: 'published',
        },
        {
          sortable: false,
          text: '',
          width: '1%',
        },
      ],
      productToDelete: null,
      deleteDialog: false,
      search: undefined,
    }),
    computed: {
      items () {
        return this.$store.state.productsAdmin.adminList.map(item => {
          return {
            ...item,
            vendor: this.getVendorNameById(item.vendorId),
          }
        }).sort((a, b) => {
          if (a.vendor < b.vendor) return -1
          if (a.vendor > b.vendor) return 1
          return 0
        })
      },
      deleteProductMessage () {
        return this.productToDelete ? this.$t('Components.Dialogs.DeleteProduct.DeleteProductMessage', [this.productToDelete.displayName, this.productToDelete.variants.length]) : null
      },
      ...mapGetters(['getVendorNameById']),
    },
    created: function () {
      if (this.$store.state.productsAdmin.adminList.length === 0) {
        this.refreshAdminProducts()
      }
    },
    methods: {
      async refreshAdminProducts () {
        this.$store.dispatch('RefreshAdminProducts')
      },
      gotoDetails (item) {
        this.$router.push({ name: 'ManageProduct', params: { productUid: item.uid } })
      },
      gotoNew (item) {
        this.$router.push({
          name: 'ManageProduct',
        })
      },
      showDeleteModal (item) {
        this.productToDelete = item
        this.deleteDialog = true
      },
      async deleteProduct () {
        await this.$store.dispatch('DeleteProduct', this.productToDelete.uid)
        this.deleteDialog = false
      },
      cancelProductDeletion () {
        this.productToDelete = null
        this.deleteDialog = false
      },
    },
  }
</script>
